import { render } from "./Trashbin.vue?vue&type=template&id=ce7bc910&scoped=true"
import script from "./Trashbin.vue?vue&type=script&lang=js"
export * from "./Trashbin.vue?vue&type=script&lang=js"

import "./Trashbin.vue?vue&type=style&index=0&id=ce7bc910&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce7bc910"]])

export default __exports__